import { NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { ModalModule } from 'ngx-bootstrap/modal';

import { DriverEventsService } from './services/driver-events.service';
import { GeolocationService } from './services/geolocation.service';
import { DriverEventsConfirmationModalComponent } from './components/driver-events-confirmation-modal/driver-events-confirmation-modal.component';
import { DriverEventsComponent } from './components/driver-events/driver-events.component';
import { NoteComponent } from './components/note/note.component';


@NgModule({
    imports: [
        CommonModule,
        HttpClientModule,
        ModalModule.forRoot(),

        NoteComponent
    ],
    exports: [
        DriverEventsComponent
    ],
    declarations: [
        DriverEventsComponent,
        DriverEventsConfirmationModalComponent
    ],
    providers: [
        DriverEventsService,
        GeolocationService,
        DatePipe
    ],
})
export class DriverEventsModule { }
